import { RestUrl } from "../common/cyan.types";

export class BuilderUserUrl {
  public static getMyInfo: RestUrl = ["GET", "/builder-user/my"];
}
